import i18n from "./../i18n";

const defaultMaxInputLength = 50;
export default class ValidationRules {
  required(value) {
    return !!value || i18n.t("mandatoryField");
  }
  inputLength(value, maxLength = defaultMaxInputLength) {
    return (
      (value && value.length <= maxLength) ||
      i18n.t("inputLengthNotValid", {
        maxLength
      })
    );
  }
  noSpaces(value) {
    return (value || "").split(" ").length <= 1 || i18n.t("noSpaceAllowedMsg");
  }
  oneSpaceAllowed(value) {
    return (
      (value || "").split(" ").length <= 2 || i18n.t("noExtraSpaceAllowedMsg")
    );
  }
  dateFormat(value) {
    const pattern =
      /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/;
    return pattern.test(value) || i18n.t("dateFormatNotValid");
  }
  emailFormat(value) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !value || pattern.test(value) || i18n.t("emailFormatNotValid");
  }
  fiscalCodeFormat(value) {
    const pattern = /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\d{3}[A-Za-z]$/;
    return pattern.test(value) || i18n.t("fiscalCodeFormatNotValid");
  }
  checkMandatory(value) {
    return value || i18n.t("mandatoryField");
  }
  passwordFormat(value) {
    const pattern =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&_\*\-\+='|(){}[\]:;"<>,.?\/])(?=.{8,})/;
    return pattern.test(value) || i18n.t("passwordFormatNotValid");
  }
  passwordMatch(password1, password2, field) {
    return (
      password1 === password2 ||
      i18n.t("passwordDoesNotMatchWithPassword", {
        field
      })
    );
  }
  vatNumberFormat(value) {
    const pattern = /^\d{11}$/;
    return pattern.test(value) || i18n.t("vatNumberFormatNotValid");
  }
}
